<template>
  <div id="termlyreport">
    <div class="row">
      <div class="col-lg-12 reportArea">
        <div class="row reportAreaTitlePart">
          <div class="col-lg-12 reportAreaTitle"><i class="material-icons">assignment</i> {{ lang('Summative Report History') }}</div>
        </div>
        <div v-if="mode === 'Pending' || mode === 'View' || mode === 'Draft'" class="reportAreaTitlePart">
          <div v-if="mode === 'View'">
            <div style="height: 20px"></div>
          </div>
        </div>
        <div v-if="mode !== 'Pending' && mode !== 'View' && mode !== 'Draft'" class="row reportAreaContentPart" id="reportAreaContentPart">
          <div class="col-lg-2">
            <label class="font">{{ lang('Academic Year') }}</label>
            <academic-year-select v-model="ddlSelectedAcademicYearID" class="pro-edt-select slAcademicYear" @change="onAcademicYearChange()" />
          </div>
          <div class="col-lg-2">
            <label class="lblSelectClass font">{{ lang('Select Class') }}</label>
            <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select slClass" @change="LoadStudents()" id="ddlClass">
              <el-option
                v-for="item in ddlClassList"
                :key="item.PK_Class_ID"
                :label="item.CLS_ClassName.trim() + ' ' + item.CLS_Batch.trim()"
                :value="ddlSelectedAcademicYearID + ',' + item.PK_Course_ID.trim() + ',' + item.PK_Class_ID.trim()"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-lg-2">
            <label class="lblSelectStudent font">{{ lang('Select Student') }}</label>
            <el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select slStudent" @change="action('List', '')" id="ddlStudent">
              <el-option v-for="item in dllStudentList" :key="item.Student_ID" :label="item.Student_Name.trim()" :value="item.Student_ID"> </el-option>
            </el-select>
          </div>
          <div class="col-lg-2">
            <label class="font d-block">&nbsp;</label>
            <el-date-picker
              style="border: none; width: 100%"
              v-model="filterByDateRange"
              type="daterange"
              :range-separator="lang('ETo')"
              :start-placeholder="lang('Start Date')"
              :end-placeholder="lang('End Date')"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              @change="action('List', '')"
            >
            </el-date-picker>
          </div>
          <div class="col-lg-1">
            <label class="font d-block">&nbsp;</label>
            <span class="spSearchIcon" @click="action('ListSearch', '')"><i class="material-icons searchIcon">search</i></span>
          </div>
        </div>
        <div v-if="mode === 'No'" class="col-lg-12 empty-list_image reportAreaContentPart2" id="divEditList">
          <strong v-if="ddlClass === ''">{{ lang('Select Class') }}</strong>
          <strong v-else>{{ lang('Select Action') }}</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="mode === 'List'" class="row reportAreaContentPart2" id="divEditList">
          <div v-if="termlyReportListInt.length < 1" class="col-lg-12 empty-list_image">
            <strong>{{ lang('No Termly Report Found') }}...</strong>
            <img src="../assets/notfound.png" />
          </div>
          <div v-if="termlyReportListInt.length > 0" class="col-lg-12">
            <data-tables :data="termlyReportListInt" class="listTable">
              <el-table-column
                v-for="termlyReportListInfo in termlyReportList"
                :prop="termlyReportListInfo.prop"
                :label="termlyReportListInfo.label"
                :key="termlyReportListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column :label="lang('Status')" width="150px">
                <template slot-scope="scope">
                  <button
                    @click="action(scope.row.TeRpStatus, scope.row.TeRpID, scope.row.TeRpStudentID)"
                    :class="scope.row.TeRpStatus === 'Active' ? 'actionButtonActive' : 'actionButtonPending'"
                  >
                    {{ lang(scope.row.TeRpStatus) }}
                  </button>
                </template>
              </el-table-column>
              <el-table-column :label="lang('Action')" width="100px">
                <template slot-scope="scope">
                  <button class="actionButtonActive" @click="action('Active', scope.row.TeRpID, scope.row.TeRpStudentID)">
                    {{ lang('View') }}
                  </button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
        <div v-if="mode === 'Pending' || mode === 'View' || mode === 'Draft'" class="row reportAreaContentPart2">
          <div class="col-lg-6 reportAreaContentPart2ReportType">
            <label v-if="mode === 'Pending' || mode === 'View'" class="lblTermlyReportList">{{ lang('Termly Report List') }}</label>
          </div>
          <div class="col-lg-6 reportAreaContentPart2Button">
            <div v-if="mode === 'Pending' || mode === 'View' || mode === 'Draft'">
              <el-button v-on:click="action('BackToList', '')" class="font btnBackToList">
                {{ lang('Back To List') }}
              </el-button>
            </div>
          </div>
          <div v-if="mode === 'Pending' || mode === 'View' || mode === 'Draft'" class="col-lg-12 row reportAreaContentPart2NameClass">
            <div class="col-lg-6">
              {{ currentClassStudentName }}
            </div>
            <div class="col-lg-6" style="text-align: right" v-if="nextSave">
              <el-button v-on:click="saveTermlyReportComments()" class="font btnSave">
                {{ lang('Save') }}
              </el-button>
              <el-button v-on:click="submitTermlyReport()" v-if="checkSubmit" class="font btnDownload">
                {{ lang('Submit') }}
              </el-button>
              <el-button v-if="mode === 'Draft' && checkNew()" v-on:click="updateTermlyReport('Delete')" class="font btnSave">
                {{ lang('Delete') }}
              </el-button>
            </div>
            <div class="col-lg-6" style="text-align: right" v-if="nextTurn || (userID === 'CON202100053436' && mode !== 'View')">
              <el-button v-on:click="signTermlyReportComments('Approved')" class="font btnSave">
                {{ lang('Approve') }}
              </el-button>
              <el-button v-on:click="signTermlyReportComments('Reject')" class="font btnSave">
                {{ lang('Reject') }}
              </el-button>
            </div>
            <div class="col-lg-6" style="text-align: right" v-if="mode === 'View'">
              <el-button v-on:click="downloadTermlyReport()" class="actionButton btnDownload">
                {{ lang('Download') }}
              </el-button>
            </div>
          </div>
          <div v-if="1 === 2">
            <!--<div v-if="mode === 'New'" class="col-lg-12 reportAreaContentPart2SelectTeacher row" style="padding: 0px; ">-->
            <!--<div class="col-lg-12">-->
            <!--<label class="font">Invite Teacher</label>-->
            <!--</div>-->
            <!--<div class="col-lg-4">-->
            <!--<label class="font">Teacher</label>-->
            <!--<el-select v-model="ddlClassTeacher" placeholder="Select Teacher" class="pro-edt-select slTeacher">-->
            <!--<el-option-->
            <!--v-for="item in classTeacherList"-->
            <!--:key="item.CONid"-->
            <!--:label="item.CONname"-->
            <!--:value="item.CONid">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</div>-->
            <!--<div class="col-lg-4">-->
            <!--<label class="font">Role</label>-->
            <!--<input type="text" class="form-control" v-model="inputTeacherType">-->
            <!--</div>-->
            <!--<div class="col-lg-2">-->
            <!--<label class="font" style="text-align: center;">Main</label>-->
            <!--<el-checkbox v-model="checkedTeacher" style="text-align: center;"></el-checkbox>-->
            <!--</div>-->
            <!--<div class="col-lg-2">-->
            <!--<label>&nbsp;</label>-->
            <!--<el-button v-on:click="addTeacher()" class="actionButton btnDownload">-->
            <!--Add-->
            <!--</el-button>-->
            <!--</div>-->
            <!--<div class="col-lg-12">-->
            <!--<div v-if="selectedTeacherList.length>0" class="col-lg-12">-->
            <!--<data-tables :data="selectedTeacherList" class="listTable">-->
            <!--<el-table-column v-for="selectedTeacherListColumnInfo in selectedTeacherListColumn" :prop="selectedTeacherListColumnInfo.prop"-->
            <!--:label="selectedTeacherListColumnInfo.label" :key="selectedTeacherListColumnInfo.prop"-->
            <!--sortable="custom">-->
            <!--</el-table-column>-->
            <!--<el-table-column label="Main" width="200px">-->
            <!--<template slot-scope="scope">-->
            <!--<span v-if="scope.row.Checked">Yes</span>-->
            <!--<span v-if="!scope.row.Checked">No</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="Delete" width="200px">-->
            <!--<template slot-scope="scope">-->
            <!--<el-button v-on:click="deleteTeacher(scope.row)" class="actionButton btnDownload">-->
            <!--Delete-->
            <!--</el-button>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--</data-tables>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
          </div>
          <div class="col-lg-12 reportAreaContentPart2Header">
            <div id="divNewTitle">
              <label class="font">{{ lang('Title') }}</label>
              <el-input v-if="userMain" type="textarea" autosize v-model="termlyReportHeader" class="mb-2"></el-input>
            </div>
            <div v-if="mode !== 'New'">
              <div v-for="(flowInfo, index) in userFlow">
                <div v-if="flowInfo.Type === 'Creator' || flowInfo.Type === 'Main'">
                  <div v-for="comment in getCommentByDomain('', 'header', flowInfo.ConID)">
                    <div class="groupComment row">
                      <label class="font eachCommentNo1"></label>
                      <label class="font eachCommentComment1" v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                      <label class="font eachCommentInfo1">{{ comment.CONname }}</label>
                      <label
                        class="font"
                        :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                        v-if="nextTurn"
                        @click="editComment(comment)"
                      >
                        <span><i class="material-icons">create</i></span>
                      </label>
                    </div>
                    <div v-if="nextTurn && comment.editComment" class="groupComment row">
                      <div class="editCommentValue">
                        <!--<el-input type="textarea" autosize v-model="comment.editCommentValue" class="mb-2"></el-input>-->
                        <K2Textarea rows="2" v-model="comment.editCommentValue" />
                      </div>
                      <div class="editCommentButton">
                        <el-button v-on:click="updateComment(comment)" class="font btnSubmit" style="background: #426dff">
                          {{ lang('Save') }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 reportAreaContentPart2StudentInfo">
            <div>
              <label>{{ lang('Student Information') }}</label>
            </div>
            <hr />
            <div class="row divStudentInfo">
              <div class="col-lg-6">
                <label class="font">{{ lang('Name of child') }}: {{ studentInfoPartName }}</label>
              </div>
              <div class="col-lg-6">
                <label class="font">{{ lang('Current Age') }}: {{ studentInfoPartAge }}</label>
              </div>
              <div class="col-lg-6">
                <label class="font">{{ lang('Date of Birth') }}: {{ studentInfoPartDob }}</label>
              </div>
              <div class="col-lg-6">
                <label class="font">{{ lang('Class') }}: {{ studentInfoPartClass }}</label>
              </div>
            </div>
            <div v-if="userMain" class="groupInput">
              <label class="font">{{ lang('Remark') }}</label>
              <el-input type="textarea" autosize v-model="termlyReportContent"></el-input>
            </div>
            <div v-else>
              <label class="font">{{ lang('Remark') }}</label>
            </div>
            <div v-if="mode !== 'New'">
              <div v-for="(flowInfo, index) in userFlow">
                <div v-if="flowInfo.Type === 'Creator' || flowInfo.Type === 'Main'">
                  <div v-for="comment in getCommentByDomain('', 'content', flowInfo.ConID)">
                    <div class="groupComment row">
                      <label class="font eachCommentNo1"></label>
                      <label class="font eachCommentComment1" v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                      <label class="font eachCommentInfo1">{{ comment.CONname }}</label>
                      <label
                        class="font"
                        :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                        v-if="nextTurn"
                        @click="editComment(comment)"
                      >
                        <span><i class="material-icons">create</i></span>
                      </label>
                    </div>
                    <div v-if="nextTurn && comment.editComment" class="groupComment row">
                      <div class="editCommentValue">
                        <!--<el-input type="textarea" autosize v-model="comment.editCommentValue" class="mb-2"></el-input>-->
                        <K2Textarea rows="4" v-model="comment.editCommentValue" />
                      </div>
                      <div class="editCommentButton">
                        <el-button v-on:click="updateComment(comment)" class="font btnSubmit" style="background: #426dff">
                          {{ lang('Save') }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 reportAreaContentPart2Summary">
            <div class="reportAreaContentPart2SummaryTitle">
              <label class="lblReportAreaContentPart2Summary">{{ lang('Summary of In School Learning') }}</label>
            </div>
            <hr />
            <div class="divEachDomain" v-for="domain in groupDomain">
              <div>
                <label class="font"
                  >{{ domain.Domain }}
                  <span v-for="(item, key, index) in groupDomainMapChinese" v-if="domain.Domain === item">{{ key }}</span>
                </label>
              </div>
              <div v-if="userMain">
                <div class="groupInput">
                  <label class="font">{{ lang('Comment') }}</label>
                  <!--<el-input type="textarea" autosize v-model="domain.Comment"></el-input>-->
                  <K2Textarea rows="4" v-model="domain.Comment" style="flex: 1" />
                </div>
              </div>
              <div v-if="mode !== 'New'">
                <div v-for="(flowInfo, index) in userFlow">
                  <div v-if="flowInfo.Type === 'Creator' || flowInfo.Type === 'Main'">
                    <div v-for="comment in getCommentByDomain(domain.Domain, 'data', flowInfo.ConID)">
                      <div class="groupComment row">
                        <label class="font eachCommentNo1"></label>
                        <label class="font eachCommentComment1" v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                        <label class="font eachCommentInfo1">{{ comment.CONname }}</label>
                        <label
                          class="font"
                          :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                          v-if="nextTurn"
                          @click="editComment(comment)"
                        >
                          <span><i class="material-icons">create</i></span>
                        </label>
                      </div>
                      <div v-if="nextTurn && comment.editComment" class="groupComment row">
                        <div class="editCommentValue">
                          <!--<el-input type="textarea" autosize v-model="comment.editCommentValue" class="mb-2"></el-input>-->
                          <K2Textarea rows="4" v-model="comment.editCommentValue" />
                        </div>
                        <div class="editCommentButton">
                          <el-button v-on:click="updateComment(comment)" class="font btnSubmit" style="background: #426dff">
                            {{ lang('Save') }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 reportAreaContentPart2Summary">
            <div class="reportAreaContentPart2SummaryTitle">
              <label class="lblReportAreaContentPart2Summary">{{ lang('Comments from the Language Specialist Teachers') }}</label>
            </div>
            <hr />
            <div class="divEachDomain" v-for="flowInfo in userFlow">
              <div v-if="flowInfo.Type === 'NonMain'">
                <div v-if="mode === 'Draft' && !userMain && flowInfo.ConID === userID">
                  <div>
                    <label class="font">{{ flowInfo.ConName }} ( {{ flowInfo.Position }} )</label>
                  </div>
                  <div class="groupInput">
                    <label class="font">{{ lang('Comment') }}</label>
                    <el-input type="textarea" autosize v-model="singleComment"></el-input>
                  </div>
                </div>
                <div v-for="(comment, index) in getCommentByDomain('', 'single', flowInfo.ConID)">
                  <div>
                    <label class="font">{{ flowInfo.ConName }} ( {{ flowInfo.Position }} )</label>
                  </div>
                  <div class="groupComment row">
                    <label class="font eachCommentNo2"></label>
                    <label class="font eachCommentComment2" v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                    <label
                      class="font"
                      :class="comment.editComment ? 'eachCommentEditComment1_Active' : 'eachCommentEditComment1'"
                      v-if="nextTurn"
                      @click="editComment(comment)"
                    >
                      <span><i class="material-icons">create</i></span>
                    </label>
                  </div>
                  <div v-if="nextTurn && comment.editComment" class="groupComment row">
                    <div class="editCommentValue">
                      <!--<el-input type="textarea" autosize v-model="comment.editCommentValue" class="mb-2"></el-input>-->
                      <K2Textarea rows="4" v-model="comment.editCommentValue" />
                    </div>
                    <div class="editCommentButton">
                      <el-button v-on:click="updateComment(comment)" class="font btnSubmit" style="background: #426dff">
                        {{ lang('Save') }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import { lang } from '../locale/index'
import Vue from 'vue'
import K2Textarea from '../uiComponents/k2Input/k2Textarea'
import AcademicYearSelect from '../components/AcademicYearSelect.vue'

export default {
  name: 'TermlyReportPreviousYears',
  components: {
    K2Textarea,
    AcademicYearSelect,
  },
  data() {
    return {
      userID: '',
      ddlSelectedAcademicYearID: '',
      ddlStudent: '',
      dllStudentList: [],
      ddlClass: '',
      ddlClassList: [],
      mode: 'No',
      currentClassStudentName: '',
      currentTermlyReportID: '',
      nextTurn: false,
      userMain: false,
      userFlow: [],
      nextSave: false,

      ddlClassTeacher: '',
      classTeacherList: [],
      inputTeacherType: '',
      checkedTeacher: false,
      checkSubmit: false,

      selectedTeacherList: [],
      selectedTeacherListColumn: [
        {
          prop: 'Name',
          label: 'Name',
        },
        {
          prop: 'Type',
          label: 'Role',
        },
      ],

      termlyReportListInt: [],
      termlyReportList: [
        {
          prop: 'StudentName',
          label: lang('Student Name'),
        },
        {
          prop: 'Title',
          label: lang('Title'),
        },
        {
          prop: 'TeRpCreatedOn_convert',
          label: lang('Date'),
        },
      ],

      termlyReportHeader: '',
      termlyReportContent: '',
      groupDomain: [
        { Domain: 'The Child as Communicator' },
        { Domain: 'The Child in a Social-Cultural Context' },
        { Domain: 'The Thinking Child' },
        { Domain: 'The Physical Child' },
        { Domain: 'The Child as an Agent of Change' },
      ],
      groupDomainMapChinese: {},
      termlyReportDomainComment: [],

      flowDone: [],

      studentInfoPartName: '',
      studentInfoPartAge: '',
      studentInfoPartDob: '',
      studentInfoPartClass: '',
      teacherAndApproverList: [],

      singleComment: '',

      linkID: '',
      filterByDateRange: null,
    }
  },
  props: ['passTermlyReportID'],
  async created() {
    this.getClassTeacher()
    this.GetTermlyReportDomainMapping()
  },
  async mounted() {
    this.userID = Cookies.get('userIDSession')

    if (this.$route.query.termlyreportid !== undefined) {
      this.linkID = this.$route.query.termlyreportid
    }

    if (this.linkID !== '') {
      this.$router.replace({ query: null })

      let result = await this.getTermlyReportInfoByLink(this.linkID)

      this.ddlStudent = result.Table[0].StudentID
      this.ddlClass = '0,0,' + result.Table[0].ClassID

      this.action('Pending', result.Table[0].TermlyReportID)
    }
  },
  methods: {
    lang,
    async GetTermlyReportDomainMapping() {
      try {
        // groupDomainMapChinese: {
        //     '善交流的儿童' : 'The Child as Communicator',
        //     '社会文化中的儿童' : 'The Child in a Social-Cultural Context',
        //     '好思考的儿童' : 'The Thinking Child',
        //     '身体健康的儿童' : 'The Physical Child',
        //     '与时俱进的儿童' : 'The Child as an Agent of Change',
        // },
        let tempGroupDomainMapChinese = {}

        const response = await DataSource.shared.getTermlyReportDomainMapping()
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Domain Mapping: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Domain Mapping: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            response.Table.forEach(m => {
              Vue.set(tempGroupDomainMapChinese, m.PlnDpMmSub, m.PlnDpMmMain)
            })

            this.groupDomainMapChinese = tempGroupDomainMapChinese
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async onAcademicYearChange() {
      this.ddlClass = ''
      this.ddlStudent = ''
      this.dllStudentList = []
      this.clear('changeAction')
      await this.BindClasses()
    },
    async BindClasses() {
      try {
        const response = await DataSource.shared.getClassIncludeClosed(this.ddlSelectedAcademicYearID)
        if (response) {
          if (response.code === '2') {
            console.log('Get Class Include Closed: No Record')
          } else if (response.code === '99') {
            console.log('Get Class Include Closed: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.ddlClassList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadStudents() {
      try {
        this.clear('changeClass')

        this.$vs.loading()

        const response = await DataSource.shared.getClassStudentByClassIDIncludeInactive(this.ddlClass)
        if (response) {
          if (response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'No Student Found...',
            })
          } else if (response.code === '99') {
            console.log('Get Class Student Include Inactive: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.dllStudentList = response.Table
          }
        }

        this.$vs.loading.close()
        this.action('List', '')
      } catch (e) {
        this.results = e
      }
    },
    async getClassTeacher() {
      try {
        const response = await DataSource.shared.getTeacherListBySchool()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.classTeacherList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadTermlyReporList() {
      try {
        this.$vs.loading()

        let dateFrom, dateTo
        if (this.filterByDateRange && this.filterByDateRange.length) {
          dateFrom = this.filterByDateRange[0]
          dateTo = this.filterByDateRange[1]
        }

        const currentClassID = this.ddlClass.split(',')
        const response = await DataSource.shared.getTermlyReportList(this.ddlStudent, currentClassID[2], dateFrom, dateTo)
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report List: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report List: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.termlyReportListInt = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async SaveTermlyRepor() {
      try {
        // let missDomainComment = false;
        // this.groupDomain.forEach(m => {
        //     if(!missDomainComment) {
        //         if(m.Comment === '' || m.Comment === undefined || m.Comment === null){
        //             missDomainComment = true;
        //         }
        //     }
        // });

        // if (this.termlyReportHeader === '' || this.termlyReportContent === ''){
        //     this.$notify.error({
        //         title: 'Required',
        //         message: 'Required Header and Content...'
        //     });
        // } else if (missDomainComment) {
        //     this.$notify.error({
        //         title: 'Required',
        //         message: 'Required all Domain comment...'
        //     });

        this.$vs.loading()

        let currentClassID = this.ddlClass.split(',')

        let domainComments = []
        this.groupDomain.forEach(m => {
          let tempCommentDs = {
            Domain: m.Domain,
            Comment: m.Comment,
          }

          domainComments.push(tempCommentDs)
        })

        let teacherApproverList = this.teacherAndApproverList

        const response = await DataSource.shared.saveTermlyReport(
          this.ddlStudent,
          currentClassID[2],
          this.termlyReportHeader,
          this.termlyReportContent,
          JSON.stringify(domainComments),
          JSON.stringify(this.selectedTeacherList),
          JSON.stringify(teacherApproverList)
        )
        if (response) {
          if (response.code === '99') {
            console.log('Save Summative Report: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'Required',
              message: 'Required Teacher/Coordinator/Principle...',
            })
          } else {
            this.$notify({
              title: 'Saved',
              message: 'Summative Report Saved...',
            })

            this.clear('All')
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async getTermlyReport(termlyReportID) {
      try {
        const response = await DataSource.shared.getTermlyReport(termlyReportID)
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            if (this.mode === 'Draft') {
              //check if user is main or creator
              response.dsFlow.Flow.forEach(m => {
                if (m.ConID === this.userID) {
                  this.nextSave = true

                  if (m.Type === 'Creator' || m.Type === 'Main') {
                    this.userMain = true

                    if (m.Type === 'Creator') {
                      this.checkSubmit = true
                    }
                  }
                }
              })
              //check if user is main or creator

              //main table to user flow
              this.userFlow = response.dsFlow.Flow
              //main table to user flow

              //main table to for comment
              this.termlyReportDomainComment = response.dsKgm_TermlyReportComment.Table

              this.termlyReportDomainComment = this.termlyReportDomainComment.map(m => {
                m.editComment = false
                m.editCommentValue = ''
                return m
              })
              //main table to for comment

              //set header if user if main or creator
              if (this.userMain) {
                this.termlyReportDomainComment.forEach(m => {
                  if (m.TeRpCMType === 'Header' && m.TeRpCMConID === this.userID) {
                    this.termlyReportHeader = m.TeRpCMComment
                  } else if (m.TeRpCMType === 'Content' && m.TeRpCMConID === this.userID) {
                    this.termlyReportContent = m.TeRpCMComment
                  }
                })
              }
              //set header if user if main or creator

              //set all domains if user if main or creator
              if (this.userMain) {
                this.termlyReportDomainComment.forEach(m => {
                  if (m.TeRpCMType === 'Domain' && m.TeRpCMConID === this.userID) {
                    this.groupDomain.forEach(m2 => {
                      if (m2.Domain === m.TeRpCMDomain) {
                        m2.Comment = m.TeRpCMComment
                      }
                    })
                  }
                })
              }
              //set all domains if user if main or creator

              //set single comment for non main
              if (!this.userMain) {
                this.termlyReportDomainComment.forEach(m => {
                  if (m.TeRpCMType === 'Single' && m.TeRpCMConID === this.userID) {
                    this.singleComment = m.TeRpCMComment
                  }
                })
              }
              //set single comment for non main
            } else if (this.mode === 'Pending' || this.mode === 'View') {
              this.userFlow = response.dsFlow.Flow
              this.termlyReportDomainComment = response.dsKgm_TermlyReportComment.Table

              this.termlyReportDomainComment = this.termlyReportDomainComment.map(m => {
                m.editComment = false
                m.editCommentValue = ''
                return m
              })
            }
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async checkTermlyReportFlow(termlyReportID) {
      try {
        let currentClassID = this.ddlClass.split(',')

        const response = await DataSource.shared.checkTermlyReportFlow(termlyReportID, currentClassID[2])
        if (response) {
          if (response.code === '1') {
            this.nextTurn = true
          } else if (response.code === '2') {
            this.nextTurn = false
          } else if (response.code === '99') {
            console.log('Check Summative Report Flow: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            window.location.replace('/')
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async saveTermlyReportComments() {
      try {
        this.$vs.loading()

        let currentClassID = this.ddlClass.split(',')
        let domainComments = []

        if (this.userMain) {
          //header
          let tempCommentHeader = {
            Domain: 'Header',
            Comment: this.termlyReportHeader,
            Type: 'Header',
          }

          domainComments.push(tempCommentHeader)

          //content
          let tempCommentContent = {
            Domain: 'Content',
            Comment: this.termlyReportContent,
            Type: 'Content',
          }

          domainComments.push(tempCommentContent)

          //domain
          this.groupDomain.forEach(m => {
            let tempCommentDomain = {
              Domain: m.Domain,
              Comment: m.Comment,
              Type: 'Domain',
            }

            domainComments.push(tempCommentDomain)
          })
        } else {
          let tempCommentDomain = {
            Domain: 'Single',
            Comment: this.singleComment,
            Type: 'Single',
          }

          domainComments.push(tempCommentDomain)
        }

        const response = await DataSource.shared.saveTermlyReportComments(this.currentTermlyReportID, JSON.stringify(domainComments), currentClassID[2])
        if (response) {
          if (response.code === '99') {
            console.log('Save Summative Report: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'Invalid',
              message: 'Invalid Action...',
            })
          } else {
            this.$notify({
              title: 'Saved',
              message: 'Summative Report Saved...',
            })

            this.clear('All')
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async downloadTermlyReport() {
      try {
        try {
          this.$vs.loading()
          const response = await DataSource.shared.generateDownloadTermlyReportPDF(this.currentTermlyReportID)
          if (response) {
            this.$vs.loading.close()

            var byteChar = atob(response)
            var byteNo = new Array(byteChar.length)
            for (var i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }

            var byteArray = new Uint8Array(byteNo)
            var file = new Blob([byteArray], { type: 'application/pdf;base64' })
            var fileUrl = URL.createObjectURL(file)

            window.open(fileUrl, '_blank', 'width=500, height=500')

            this.$vs.loading.close()
          }
        } catch (e) {
          this.results = e
        }
      } catch (e) {
        this.results = e
      }
    },
    async getTermlyReportFlow() {
      try {
        this.$vs.loading()

        let currentClassID = this.ddlClass.split(',')

        const response = await DataSource.shared.getTermlyReportFlow(this.currentTermlyReportID, currentClassID[2])
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Flow: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Flow: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.flowDone = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async getTermlyReportStudentInfoPart() {
      try {
        let currentClassID = this.ddlClass.split(',')

        const response = await DataSource.shared.getTermlyReportStudentInfoPart(this.ddlStudent, currentClassID[2])
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Student Info Part : No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Student Info Part : Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.studentInfoPartName = response.ds.Table[0].Name
            this.studentInfoPartAge = response.ds.Table[0].Age
            this.studentInfoPartDob = response.ds.Table[0].Dob

            this.teacherAndApproverList = response.dsTeacherAndApprover.Table
            this.teacherAndApproverList.forEach(m => {
              if (m.Role === 'Mandarin Teacher' || m.Role === 'Coordinator' || m.Role === 'Principal') {
                m.RoleType = 'NonLanguageTeacher'
                m.RoleTypeActive = 'Yes'
              } else {
                m.RoleType = 'LanguageTeacher'
                m.RoleTypeActive = 'Yes'
              }
            })

            let currentClassID = this.ddlClass.split(',')
            let currentClassName = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2])
            this.studentInfoPartClass = currentClassName[0].CLS_ClassName
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async submitTermlyReport() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.submitTermlyReport(this.currentTermlyReportID)
        if (response) {
          if (response.code === '99') {
            console.log('Submit Summative Report: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'Required',
              message: 'Pending action from teacher...',
            })
          } else {
            this.$notify({
              title: 'Submitted',
              message: 'Summative Report Submitted...',
            })

            this.clear('All')
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async signTermlyReportComments(value) {
      this.$vs.loading()

      let currentClassID = this.ddlClass.split(',')

      const response = await DataSource.shared.signTermlyReportComments(this.currentTermlyReportID, currentClassID[2], value)
      if (response) {
        if (response.code === '99') {
          console.log('Sign Summative Report Comments: Error')
        } else if (response.code === '88') {
          window.location.replace('/')
        } else {
          this.$notify({
            title: 'Signed',
            message: 'Summative Report Signed...',
          })

          this.clear('All')
        }
      }

      this.$vs.loading.close()
    },
    async getTermlyReportInfoByLink(inputString) {
      try {
        const response = await DataSource.shared.getTermlyReportInfoByLink(decodeURI(inputString))
        if (response) {
          if (response.code === '99') {
            console.log('Get Summative Report Info By Link : Error')
            return ''
          } else if (response.code === '88') {
            window.location.replace('/')
            return ''
          } else {
            return response
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async updateTermlyReport(mode) {
      try {
        if (mode === 'Delete') {
          this.$vs.loading()

          const response = await DataSource.shared.updateTermlyReport(this.currentTermlyReportID, mode)
          if (response) {
            if (response.code === '99') {
              console.log('Update Summative Report : Error')
              return ''
            } else if (response.code === '88') {
              window.location.replace('/')
              return ''
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Invalid',
                message: 'Invalid Action...',
              })
            } else {
              this.clear('All')
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async updateComment(value) {
      try {
        if (value.editCommentValue === '') {
          this.$notify.error({
            title: 'Required',
            message: 'Edit Comment Required...',
          })
        } else {
          this.$vs.loading()

          const response = await DataSource.shared.updateTermlyReportCommentsByApproval(value.TeRpCMTeRpID, value.TeRpCMID, value.editCommentValue)

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Update Summative Report Comments By Approval: ERROR!!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Invalid',
                message: 'Invalid Action...',
              })
            } else {
              this.$notify({
                title: 'Successfully',
                message: 'Successfully Edited...',
              })

              this.action('Pending', this.currentTermlyReportID)
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    clear(value) {
      this.termlyReportListInt = []
      this.termlyReportHeader = ''
      this.termlyReportContent = ''
      this.termlyReportDomainComment = []
      this.currentTermlyReportID = ''
      this.nextTurn = false
      this.flowDone = []
      this.studentInfoPartName = ''
      this.studentInfoPartAge = ''
      this.studentInfoPartDob = ''
      this.studentInfoPartClass = ''
      this.ddlClassTeacher = ''
      this.inputTeacherType = ''
      this.selectedTeacherList = []
      this.checkedTeacher = false
      this.userMain = false
      this.userFlow = []
      this.nextSave = false
      this.singleComment = ''
      this.checkSubmit = false
      this.teacherAndApproverList = []

      this.groupDomain = [
        { Domain: 'The Child as Communicator' },
        { Domain: 'The Child in a Social-Cultural Context' },
        { Domain: 'The Thinking Child' },
        { Domain: 'The Physical Child' },
        { Domain: 'The Child as an Agent of Change' },
      ]

      if (value === 'All') {
        this.dllStudentList = []
        this.ddlStudent = ''
        this.ddlClass = ''
        this.mode = 'No'
        this.filterByDateRange = null
      } else if (value === 'changeStudent') {
        this.mode = 'No'
        this.fnCurrentClassStudentName()
      } else if (value === 'changeClass') {
        this.dllStudentList = []
        this.ddlStudent = ''
        this.mode = 'No'
      } else if (value === 'changeAction') {
      }
    },
    action(value, termlyReportID, studentID) {
      if (value === 'List') {
        if (this.ddlClass === '') {
          this.$notify({
            title: 'Required',
            message: 'Please select class....',
          })
        } else {
          this.mode = 'List'
          this.clear('changeAction')
          this.LoadTermlyReporList()
        }
      } else if (value === 'Active') {
        if (studentID) this.ddlStudent = studentID
        this.mode = 'View'
        this.clear('changeAction')
        this.currentTermlyReportID = termlyReportID
        this.getTermlyReport(termlyReportID)
        this.getTermlyReportStudentInfoPart()
      } else if (value === 'Pending') {
        if (studentID) this.ddlStudent = studentID
        this.mode = 'Pending'
        this.clear('changeAction')
        this.currentTermlyReportID = termlyReportID
        this.getTermlyReport(termlyReportID)
        this.checkTermlyReportFlow(termlyReportID)
        this.getTermlyReportFlow()
        this.getTermlyReportStudentInfoPart()
      } else if (value === 'Draft') {
        this.mode = 'Draft'
        this.clear('changeAction')
        this.currentTermlyReportID = termlyReportID
        this.getTermlyReport(termlyReportID)
        this.getTermlyReportStudentInfoPart()
      } else if (value === 'BackToList') {
        this.clear('All')
        this.mode = 'List'
      }
    },
    checkNew() {
      let currentClassID = this.ddlClass.split(',')
      let currentClassInfo = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2])

      if (currentClassInfo[0].CLS_Class_Incharge_Staff === this.userID) {
        return true
      } else {
        return false
      }
    },
    fnCurrentClassStudentName() {
      this.currentClassStudentName = 'Error'

      let currentClassID = this.ddlClass.split(',')
      let currentClassName = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2])

      let currentStudentName = this.dllStudentList.filter(m => m.Student_ID === this.ddlStudent)

      this.currentClassStudentName = currentClassName[0].CLS_ClassName
      this.currentClassStudentName += ' > ' + currentStudentName[0].First_Name

      if (currentStudentName[0].Middle_Name !== '') {
        this.currentClassStudentName += ' ' + currentStudentName[0].Middle_Name
        this.currentClassStudentName += ' ' + currentStudentName[0].Last_Name
      } else {
        this.currentClassStudentName += ' ' + currentStudentName[0].Last_Name
      }
    },
    getCommentHTML(value) {
      if (value === undefined) {
        return ''
      } else {
        return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
      }
    },
    getCommentByDomain(domain, type, userID) {
      if (type === 'data') {
        //domain comment
        if (userID !== this.userID || this.mode === 'View' || this.mode === 'Pending') {
          let result = []

          this.termlyReportDomainComment.forEach(m => {
            if (m.TeRpCMDomain === domain && m.TeRpCMConID === userID) {
              result.push(m)
            }
          })

          return result
        } else {
          return []
        }
      } else if (type === 'header') {
        //title
        if (userID !== this.userID || this.mode === 'View' || this.mode === 'Pending') {
          let result = []

          this.termlyReportDomainComment.forEach(m => {
            if (m.TeRpCMType === 'Header' && m.TeRpCMConID === userID) {
              result.push(m)
            }
          })

          return result
        } else {
          return []
        }
      } else if (type === 'content') {
        //remark
        if (userID !== this.userID || this.mode === 'View' || this.mode === 'Pending') {
          let result = []

          this.termlyReportDomainComment.forEach(m => {
            if (m.TeRpCMType === 'Content' && m.TeRpCMConID === userID) {
              result.push(m)
            }
          })

          return result
        } else {
          return []
        }
      } else if (type === 'single') {
        //single comment
        if (userID !== this.userID || this.mode === 'View' || this.mode === 'Pending') {
          let result = []

          this.termlyReportDomainComment.forEach(m => {
            if (m.TeRpCMType === 'Single' && m.TeRpCMConID === userID) {
              result.push(m)
            }
          })

          return result
        } else {
          return []
        }
      } else if (type === 'length') {
        let result = []

        this.termlyReportDomainComment.forEach(m => {
          if (m.TeRpCMDomain === domain) {
            result.push(m)
          }
        })

        return result.length
      }
    },
    addTeacher() {
      if (this.ddlClassTeacher === '') {
        this.$notify({
          title: 'Required',
          message: 'Please select teacher...',
        })
      } else if (this.inputTeacherType === '') {
        this.$notify({
          title: 'Required',
          message: 'Please key in teacher role',
        })
      } else {
        //check if teacher added
        let check = this.selectedTeacherList.filter(m => m.ID === this.ddlClassTeacher)

        if (check.length < 1) {
          //get teacher name
          let currentTeacherInfo = this.classTeacherList.filter(m => m.CONid === this.ddlClassTeacher)

          if (currentTeacherInfo.length > 0) {
            let currentTeacher = {
              ID: this.ddlClassTeacher,
              Name: currentTeacherInfo[0].CONname,
              Type: this.inputTeacherType,
              Checked: this.checkedTeacher,
            }

            this.selectedTeacherList.push(currentTeacher)

            this.ddlClassTeacher = ''
            this.inputTeacherType = ''
            this.checkedTeacher = false
          }
        } else {
          this.$notify.error({
            title: 'Invalid',
            message: 'This Teacher have been added...',
          })
        }
      }
    },
    deleteTeacher(value) {
      this.selectedTeacherList = this.selectedTeacherList.filter(m => m.ID !== value.ID)
    },
    editComment(value) {
      this.termlyReportDomainComment = this.termlyReportDomainComment.map(m => {
        if (m.TeRpCMID === value.TeRpCMID) {
          if (value.editComment === false) {
            m.editComment = true
            m.editCommentValue = m.TeRpCMComment
          } else {
            m.editComment = false
            m.editCommentValue = ''
          }
        }

        return m
      })
    },
    adddeleteLanguageTeacher(value) {
      if (value.RoleType === 'LanguageTeacher') {
        this.teacherAndApproverList = this.teacherAndApproverList.map(m => {
          if (m.ConID === value.ConID && m.Role === value.Role) {
            if (m.RoleType === 'LanguageTeacher') {
              if (value.RoleTypeActive === 'Yes') {
                m.RoleTypeActive = 'No'
              } else {
                m.RoleTypeActive = 'Yes'
              }
            }
          }

          return m
        })
      } else {
        this.$notify.error({
          title: 'Invalid',
          message: 'Invalid Action...',
        })
      }
    },
  },
}
</script>

<style scoped>
.row {
  margin-right: 0;
  margin-left: 0;
}
.font {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.reportArea {
  padding: 20px;
}
.reportAreaContentPart {
  margin-top: 30px;
  background: #f8faff;
  border-radius: 8px 8px 0 0;
  padding: 20px 0;
  border-bottom: 0.5px solid #d3d9e8;
}
.reportAreaTitle {
  text-align: left;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #536170;
}
.lblSelectClass,
.lblSelectStudent {
  color: #536170;
}
.spSearchIcon {
  background: #426dff;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}
.searchIcon {
  text-align: center;
  margin-top: 10px;
}
.slClass,
.slStudent,
.slTeacher {
  display: block;
}
.reportAreaContentPart2 {
  padding: 20px 0;
  background: #ffffff;
}
.lblNewTermlyReport,
.lblTermlyReportList {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #4f4f4f;
}
.reportAreaContentPart2ReportType,
.reportAreaContentPart2Button,
.reportAreaContentPart2Header,
.reportAreaContentPart2StudentInfo,
.reportAreaContentPart2Summary,
.reportAreaContentPart2SelectTeacher {
  margin-bottom: 40px;
}
.reportAreaContentPart2Button {
  text-align: right;
}
.empty-list_image {
  width: 100%;
}
.reportAreaContentPart2StudentInfo label,
.lblReportAreaContentPart2Summary,
.reportAreaContentPart2Header label {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #536170;
}
.groupInput {
  display: flex;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px;
}
.groupInput label {
  background: #e9edf7;
  margin: 0px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px 0px 0px 5px;
  padding: 7px 10px;
}
.reportAreaContentPart2SummaryTitle,
.divEachDomain {
  margin-bottom: 20px;
}
.btnSubmit {
  background: #ea4c89;
  border-radius: 5px;
  color: #ffffff;
}
.actionButtonActive {
  background: #19b600;
  border-radius: 5px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  border: none;
}
.actionButtonPending {
  background: #91a3b6;
  border-radius: 5px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  border: none;
}
.btnBackToList {
  background: #426dff;
  border-radius: 5px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
}
.reportAreaContentPart2NameClass {
  background: #f8faff;
  text-align: left;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-top: 1px solid #dde6fc;
  border-bottom: 1px solid #dde6fc;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #536170;
}
.groupComment {
  display: flex;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 10px;
}
.btnSave,
.btnDownload {
  background: #ea4c89;
  border-radius: 5px;
  color: #ffffff;
}
.eachCommentNo1 {
  width: 5px;
  background: #ecbc40 !important;
  text-align: center;
  color: #ffffff !important;
}
.eachCommentComment1 {
  width: calc(70% - 5px - 25px);
  background: rgba(236, 188, 64, 0.15) !important;
  text-align: left;
  color: #536170 !important;
  padding: 5px;
}
.eachCommentInfo1 {
  width: 30%;
  background: rgba(236, 188, 64, 0.15) !important;
  text-align: right;
  color: #687786 !important;
  padding: 5px;
}
.eachCommentEditComment1 {
  width: 25px;
  color: #91a3b6 !important;
  background: #e9edf7;
  cursor: pointer;
  font-size: 30px !important;
}
.eachCommentEditComment1_Active {
  width: 25px;
  color: #ffffff !important;
  background: #426dff;
  cursor: pointer;
  font-size: 30px !important;
}
.inputFilterPostTitle {
  background: #f8faff;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px;
}
.eachCommentNo2 {
  width: 5px;
  background: #ecbc40 !important;
  text-align: center;
  color: #ffffff !important;
}
.eachCommentComment2 {
  width: calc(100% - 5px - 25px);
  background: rgba(236, 188, 64, 0.15) !important;
  text-align: left;
  color: #536170 !important;
  padding: 5px;
}
.editCommentValue {
  width: calc(100% - 80px);
  text-align: left;
  padding: 5px;
}
.editCommentButton {
  width: 80px;
  text-align: right;
  padding: 5px;
}
.reportAreaTitlePart {
  margin-bottom: 10px;
}
.divStudentInfo .col-lg-6 {
  padding: 0px;
}
.divVerficationTeacherTitle {
  color: #ffffff;
  background: #426dff;
  padding: 10px;
  border-radius: 5px 5px 0px 0px;
  text-align: left;
  margin-bottom: 10px;
}
.spanVerification {
  color: #ffffff;
  font-size: 20px;
}
.spanVerificationMsg {
  color: #ffffff;
  font-size: 11px;
}
.divVerficationTeacherMsg {
  margin-bottom: 10px;
  color: #ffffff;
  background: #426dff;
  text-align: left;
  padding: 5px;
  font-size: 10px;
}
.divVerficationTeacherDetails {
  background: #f8faff;
  width: 49%;
  float: left;
  border: 1px solid rgba(145, 163, 182, 0.15);
  box-sizing: border-box;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}
.divVerficationTeacherDetailsDisable {
  background: #dde4f5 !important;
  color: #a0abc7 !important;
}
.divVerficationTeacherDetailsRight {
  margin-left: 2%;
}
.spanVerficationTeacherDetailsIcon {
  float: left;
  width: 30px;
  text-align: left;
}
.spanVerficationTeacherDetailsName {
  float: left;
  width: calc(50% - 15px);
  text-align: left;
}
.spanVerficationTeacherDetailsRole {
  float: left;
  width: calc(50% - 15px);
  text-align: left;
}
.redborder {
  border: 1px solid red;
}
</style>

<style>
#termlyreport {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  color: #536170;
}
#termlyreport .slAcademicYear .el-input__inner,
#termlyreport .slClass .el-input__inner,
#termlyreport .slStudent .el-input__inner,
#termlyreport .slTeacher .el-input__inner {
  color: #426dff;
  background: #ffffff;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px;
}
#termlyreport .reportAreaContentPart2Header .el-textarea__inner {
  background: #f8faff;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px;
}
#termlyreport .groupInput .el-textarea__inner {
  background: #f8faff;
}
#termlyreport .listTable .el-table__header-wrapper th {
  background: #e9edf7;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #222222;
}
#termlyreport .listTable .el-table__row td,
#portfolio_component .indicatorTable .el-table__empty-block {
  background: #f8faff;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #5f5f5f;
}
#termlyreport .el-date-editor .el-range-input {
  width: 100px;
}
#termlyreport .el-range-editor.el-input__inner {
  width: initial;
}
#termlyreport .el-date-editor .el-range-separator {
  min-width: 25px;
}
</style>
